/**
 * Add item/s to cart via AJAX.
 * @param {Array} formData - Array of objects containing item ID and quantity.
 * @param {HTMLElement} addToCartButton - Button that was clicked to add item/s.
 * @example: [{'id': 12345678912345, 'quantity': 1}]
 */
function addToCartAjax(formData, addToCartButton) {
  // initialize a promise to resolve after the cart has been updated
  return new Promise((resolve, reject) => {

    // Disable button to prevent double addition of item/s.
    addToCartButton.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var pageOverlayElement = document.querySelector('.PageOverlay');
    var drawerOverlayElement = document.querySelector('.Drawer--overlay');

    // Disable user from clicking anything.
    pageOverlayElement.classList.add('is-visible');
    drawerOverlayElement.classList.add('is-visible');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: formData,
      }),
    }).then(function (response) {
      if (response.ok) {
        addToCartButton.removeAttribute('disabled');

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );

        document.body.dispatchEvent(
          new CustomEvent('cart:open', {
            bubbles: true,
          })
        );

        // returns a prmose to allow for additional actions after the cart has been
        resolve('Cart updated');
      } else {
        response.json().then(function (content) {
          pageOverlayElement.classList.remove('is-visible');
          drawerOverlayElement.classList.remove('is-visible');
          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);

          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });

        reject('Failed to add item to cart');
      }
    });
  });
}
